export default __webpack_public_path__ + "static/media/cincoOpen.71c597a4.jpg";